import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Container, Box, Typography, Button } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import ExploreIcon from '@mui/icons-material/Explore';
import SaveIcon from '@mui/icons-material/Save';
import PersonIcon from '@mui/icons-material/Person';
import LoginIcon from '@mui/icons-material/Login';

// import SequenceVisualizationModal from './SequenceVisualizationModal';

import UserService from "../services/user.service";

const Home = () => {
  const [isConnected, setIsConnected] = useState(false);

  const imgSrc = require("../img/jbrowse.png");
  const style = { marginRight: "10px", height: "40px" };

  const { user: currentUser } = useSelector((state) => state.auth);

  useEffect(() => {
    UserService.getPublicContent().then(
      (response) => {
        setIsConnected(true);
      },
      (error) => {
        setIsConnected(false);
      }
    );
  }, []);

  return (
    <>
      <Container maxWidth="md" sx={{ py: 5 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            backgroundColor: "grey.200",
            justifyContent: "center",
            alignItems: "center",
            p: 5,
            borderRadius: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 3,
            }}
          >
            <img src={imgSrc} alt="logo" style={{ height: "48px", marginRight: "16px" }} />
            <Typography variant="h4" component="h1" fontWeight="bold">
              JBrowse 2+
            </Typography>
          </Box>

          <Typography variant="h6" sx={{ mb: 2 }}>
            The next-generation genome browser
          </Typography>

          <Typography 
            variant="body1" 
            align="center" 
            sx={{ 
              mb: 4,
              px: { xs: 0, sm: 2 },
              py: 2,
              lineHeight: 1.7,
              fontSize: '1.05rem',
              color: 'text.primary',
              fontWeight: 400,
              letterSpacing: '0.015em',
              textShadow: '0 1px 1px rgba(0,0,0,0.05)',
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: -4,
                left: '15%',
                width: '70%',
                height: '1px',
                background: 'linear-gradient(90deg, transparent, rgba(79, 125, 36, 0.4), transparent)',
              }
            }}
          >
            Developers at Verinomics have enhanced JBrowse2, transitioning it into a superior
            web-based genome browser. This next-level application now boasts a suite of custom tools,
            sophisticated AI analysis, and interactive chatbot features, making it the most advanced
            and user-friendly online genome browser available for modern web browsers.
          </Typography>

          {currentUser ? (
            <>
              <Button
                component={Link}
                to="/jbrowse"
                variant="contained"
                startIcon={<ExploreIcon />}
                sx={{ 
                  mb: 2, 
                  background: 'linear-gradient(45deg, #4F7D24 30%, #5C9029 90%)',
                  color: 'white',
                  borderRadius: 2,
                  boxShadow: '0 8px 16px rgba(79, 125, 36, 0.2)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  ':hover': { 
                    background: 'linear-gradient(45deg, #446B1F 30%, #4F7D24 90%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 20px rgba(79, 125, 36, 0.3)',
                    color: '#f5f5f5',
                    '& .MuiSvgIcon-root': {
                      color: '#f5f5f5'
                    }
                  }
                }}
              >
                JBrowse Wizard
              </Button>
              <Button
                component={Link}
                to="/sessions"
                variant="contained"
                startIcon={<SaveIcon />}
                sx={{ 
                  mb: 2, 
                  background: 'linear-gradient(45deg, #4F7D24 30%, #5C9029 90%)',
                  color: 'white',
                  borderRadius: 2,
                  boxShadow: '0 8px 16px rgba(79, 125, 36, 0.2)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  ':hover': { 
                    background: 'linear-gradient(45deg, #446B1F 30%, #4F7D24 90%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 20px rgba(79, 125, 36, 0.3)',
                    color: '#f5f5f5',
                    '& .MuiSvgIcon-root': {
                      color: '#f5f5f5'
                    }
                  }
                }}
              >
                Saved Sessions
              </Button>
              <Button
                component={Link}
                to="/profile"
                variant="contained"
                startIcon={<PersonIcon />}
                sx={{ 
                  mb: 2, 
                  background: 'linear-gradient(45deg, #4F7D24 30%, #5C9029 90%)',
                  color: 'white',
                  borderRadius: 2,
                  boxShadow: '0 8px 16px rgba(79, 125, 36, 0.2)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  ':hover': { 
                    background: 'linear-gradient(45deg, #446B1F 30%, #4F7D24 90%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 20px rgba(79, 125, 36, 0.3)',
                    color: '#f5f5f5',
                    '& .MuiSvgIcon-root': {
                      color: '#f5f5f5'
                    }
                  }
                }}
              >
                Profile
              </Button>
            </>
          ) : (
            <Button
              component={Link}
              to="/login"
              variant="contained"
              startIcon={<LoginIcon />}
              sx={{
                mb: 2,
                background: 'linear-gradient(45deg, #4F7D24 30%, #5C9029 90%)',
                color: 'white',
                borderRadius: 2,
                boxShadow: '0 8px 16px rgba(79, 125, 36, 0.2)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                ':hover': {
                  background: 'linear-gradient(45deg, #446B1F 30%, #4F7D24 90%)',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 12px 20px rgba(79, 125, 36, 0.3)',
                  color: '#f5f5f5',
                  '& .MuiSvgIcon-root': {
                    color: '#f5f5f5'
                  }
                }
              }}
            >
              Login
            </Button>
          )}
        </Box>
      </Container>

      {/* Connected indicator at the bottom right of the entire page */}
      {isConnected ? (
        <Box
          sx={{
            position: "fixed",
            bottom: 16,
            right: 16,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <CheckCircleIcon sx={{ color: "#7DB935" }} />
          <Typography variant="body2" sx={{ color: "#7DB935" }}>
            Connected
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            position: "fixed",
            bottom: 16,
            right: 16,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <ErrorIcon color="error" />
          <Typography variant="body2" color="error.main">
            Disconnected
          </Typography>
        </Box>
      )}
    </>
  );
};

export default Home;
